import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable()
export class MapsService {
  private get apiKey(): string {
    return AppConfigService.settings.mapsApiKey;
  }
  private promise?: Promise<void>;

  constructor(private http: HttpClient) {}

  geocodeAddress(address: string) {
    const url: string = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + this.apiKey;
    return this.http.get<any>(url);
  }

  load(): Promise<void> {
    if (this.promise) return this.promise;

    this.promise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = err => reject(err);

      document.head.appendChild(script);
    });

    return this.promise;
  }
}
